import AppHeader from '../AppHeader'
export default {
  name: 'yes-we-can',
  created () {
    window.scrollTo(0, 0)
  },
  data () {
    return {
      swiperOption: {
        speed: 500,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  computed: {
  },
  components: {
    AppHeader
  },
  methods: {
    goVideoCategories: function() {
      this.$router.push({ path: '/video_categories'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/yes-we-can.js